const upBtn = document.querySelector('.up-btn');
let windowHeight = window.innerHeight;
window.addEventListener('scroll', () => {
    if (window.scrollY > (windowHeight-50)) {
        upBtn.style.display = 'block'
    } else {
        upBtn.style.display = 'none'
    }
    if (window.scrollY > windowHeight) {
        upBtn.classList.add('show');
    } else {
        upBtn.classList.remove('show');
    }
});

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const audioFiles = [
    'moo01.wav',
    'moo02.wav',
    'moo03.wav',
    'moo04.wav',
    'moo05.wav',
    'moo06.wav',
    'moo07.wav',
    'moo08.wav',
    'moo09.wav',
    'moo10.wav',
];

upBtn.addEventListener('click', () => {
    const randomIndex = getRandomInt(0, audioFiles.length - 1);
    const selectedAudioFile = audioFiles[randomIndex];
    const audioPath = '/wp-content/plugins/custom-blocker/assets/audio/' + selectedAudioFile;

    const audio = new Audio(audioPath);
    audio.play();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});